/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
import "./logo-wrapper.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { fg } from '@atlaskit/platform-feature-flags';
import { useThemeObserver } from '@atlaskit/tokens';
const styles = {
  root: "_1e0c1o8l _vwz4idpf",
  TEMP_assets: "_9aea1fkg"
};

// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const logoTextColorMap = {
  light: "_syazqlpt",
  dark: "_syazz6c6"
};
const sizeMap = {
  xxsmall: "_4t3i7vkz",
  xsmall: "_4t3igktf",
  small: "_4t3i1tcg",
  medium: "_4t3izwfg",
  large: "_4t3i1ylp",
  xlarge: "_4t3ickbl"
};

/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
const textLightAppearanceMap = {
  brand: "_1wyc1fxt",
  neutral: "_1wyc1e01",
  inverse: "_1wycu67f",
  legacy: "_1wycu67f"
};

/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
const textDarkAppearanceMap = {
  brand: "_1wyc1fxt",
  neutral: "_1wyc1gvk",
  inverse: "_1wyc5a6q",
  legacy: "_1wycu67f"
};

/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
const cloudLightAppearanceMap = {
  brand: "_1b3i18uv _9aea18uv",
  neutral: "_1b3i1e01 _9aea1fkg",
  inverse: "_1b3i5a6q _9aeau67f",
  legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
const cloudDarkAppearanceMap = {
  brand: "_1b3i18uv _9aea18uv",
  neutral: "_1b3i1gvk _9aea8hz0",
  inverse: "_1b3iu67f _9aea5a6q",
  legacy: "_1b3iu67f _9aeadoyu"
};

/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
const dataCenterLightAppearanceMap = {
  brand: "_1b3idoyu _9aeau67f _3wu01fkg",
  neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
  inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
  legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};

/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
const dataCenterDarkAppearanceMap = {
  brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
  neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
  inverse: "_1b3i1501 _9aeau67f _3wu01501",
  legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const rovoDarkAppearanceMap = {
  brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
  neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
  inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
  legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const rovoLightAppearanceMap = {
  brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
  neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
  inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
  legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};

/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */

export function LogoWrapper({
  appearance = 'brand',
  size = 'small',
  svg,
  customThemeSvg,
  label,
  testId: userDefinedTestId,
  iconColor: customIconColor,
  textColor: customTextColor,
  isAssets = false,
  type = 'tile'
}) {
  const {
    colorMode
  } = useThemeObserver();
  const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
  const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
  return /*#__PURE__*/React.createElement("span", {
    style: {
      // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
      '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
      '--themed-text-color': customTextColor || 'inherit'
    },
    "data-testid": testId
    // If the label is provided an empty string, we want to remove the element from the accessibility tree.
    ,
    "aria-label": label ? label : undefined,
    role: label ? 'img' : undefined,
    "aria-hidden": label === '' ? true : undefined
    // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
    // This is because the SVG elements are static and will not change, so we get a little performance benefit by
    // bypassing React.
    ,
    dangerouslySetInnerHTML: {
      __html: isCustomThemed ? customThemeSvg : svg
    },
    className: ax([styles.root,
    // Setting the color so that the SVG can inherit the correct text color using "currentColor"
    logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'], sizeMap[size], colorMode === 'dark' ? textDarkAppearanceMap[appearance] : textLightAppearanceMap[appearance], colorMode === 'dark' ? dataCenterDarkAppearanceMap[appearance] : dataCenterLightAppearanceMap[appearance], type === 'rovo' ? colorMode === 'dark' ? rovoDarkAppearanceMap[appearance] : rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? cloudDarkAppearanceMap[appearance] : cloudLightAppearanceMap[appearance], isAssets && appearance === 'brand' && fg('assets-platform-branding') && styles.TEMP_assets])
  });
}